import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import VueMobileDetection from 'vue-mobile-detection'
import axios from 'axios'
// 旧ブラウザ対応(ポリフィル)
import 'whatwg-fetch'
Vue.config.productionTip = false
Vue.prototype.$axios = axios

// v-calendar bug対応 [Bug Report] warning with VueJS 2.6.11 #9999
const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.'
// eslint-disable-next-line no-unused-vars
Vue.config.warnHandler = function(msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null
    vm = null
    // eslint-disable-next-line no-unused-vars
    trace = null
  }
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')

Vue.use(VueMobileDetection)